import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { ThemeProvider, StyledEngineProvider, styled, useTheme } from '@mui/material/styles';
import { Link } from '@mui/material';
import { Marker as MarkerLeaflet, Popup } from 'react-leaflet';
import { divIcon } from 'leaflet';
import { useIntl } from 'react-intl';

import MarkerIcon from './MarkerIcon';

const StyledPopup = styled(Popup)(() => ({
  bottom: `40px !important`,
  '& a.leaflet-popup-close-button': {
    display: 'none',
  },
}));

const StyledLink = styled(Link)(({ theme }: any) => ({
  color: `${theme.palette.primary.main} !important`,
  fontWeight: theme.typography.fontWeightBold,
}));

function Marker({ title, href, status, ...props }: any) {
  const theme = useTheme();
  const intl = useIntl();

  const markerIcon = divIcon({
    className: '',
    iconSize: [46, 108], // SVG size
    html: ReactDOMServer.renderToString(
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <MarkerIcon icon={status} />
        </ThemeProvider>
      </StyledEngineProvider>,
    ),
  });

  if (title) {
    return (
      <MarkerLeaflet icon={markerIcon} {...props}>
        <StyledPopup>
          {href ? (
            <StyledLink
              variant="body2"
              href={href}
              target="_blank"
              underline="hover"
              title={intl.formatMessage({ id: 'BUTTONS.OPEN_IN_NEW_TAB' })}
            >
              {title}
            </StyledLink>
          ) : (
            title
          )}
        </StyledPopup>
      </MarkerLeaflet>
    );
  }

  return <MarkerLeaflet icon={markerIcon} {...props} />;
}

export default Marker;
